import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import CheckBlock from '../CheckBlock';
const CheckBlockGroup = t0 => {
  const $ = _c(5);
  const {
    className: t1,
    items
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `w-full space-y-4 ${className}`;
  let t3;
  if ($[0] !== items) {
    t3 = items.map(_temp);
    $[0] = items;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
CheckBlockGroup.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    description: PropTypes.string,
    onClick: PropTypes.func.isRequired
  }))
};
export default CheckBlockGroup;
function _temp(t0) {
  const {
    id,
    label,
    description,
    isSelected,
    onClick
  } = t0;
  return <CheckBlock key={id} isSelected={isSelected} onClick={onClick} label={label} description={description} />;
}